import { render, staticRenderFns } from "./UserDrilldown.vue?vue&type=template&id=0bf5280e&scoped=true&"
import script from "./UserDrilldown.vue?vue&type=script&lang=ts&"
export * from "./UserDrilldown.vue?vue&type=script&lang=ts&"
import style0 from "./UserDrilldown.vue?vue&type=style&index=0&id=0bf5280e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf5280e",
  null
  
)

export default component.exports